export async function fetchRuntimeConfig() {
  // Try the local proxied endpoint first (development); if that fails,
  // fall back to the configured VITE_API_BASE (if set).
  const API_BASE = (import.meta as any).env?.VITE_API_BASE || '';
  const localUrl = `${API_BASE}/config`;
  const envBase = API_BASE;
  const fallbackUrl = envBase ? `${envBase.replace(/\/$/, '')}/config` : '';

  try {
    let res = await fetch(localUrl);
    if (!res.ok && fallbackUrl) {
      // attempt fallback to configured API base
      res = await fetch(fallbackUrl);
    }

    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('Failed to fetch runtime config', err);
    return null;
  }
}
